"use client"
import { DASHBOARDVIEW } from "@/types/types.dashboard"
import React, { useState } from "react"
import LeaderboardComponent from "../leaderboard/leaderboardComponent"

type Props = {
    sessionTicket: string
}

const DashboardMainComponent: React.FC<Props> = (props) => {
    const [view, setView] = useState<DASHBOARDVIEW>(DASHBOARDVIEW.LEADERBOARDS)
    return (
        <>
            <section className="p-5 border border-primary my-10 block sm:flex gap-5 corner-container bg-[rgba(0,0,0,0.9)]">
                <div className="bl-corner"></div>
                <div className="br-corner"></div>
                <div className="tl-corner"></div>
                <div className="tr-corner"></div>
                <aside>
                    <ul className="space-y-2 text-[24px] font-bold uppercase">
                        {/* <li
                            onClick={() => setView(DASHBOARDVIEW.GENERAL)}
                            className={`cursor-pointer ${view === DASHBOARDVIEW.GENERAL ? "text-primary" : ""}`}
                        >
                            General
                        </li> */}
                        <li
                            onClick={() => setView(DASHBOARDVIEW.LEADERBOARDS)}
                            className={`cursor-pointer ${view === DASHBOARDVIEW.LEADERBOARDS ? "text-primary" : ""}`}
                        >
                            Leaderboards
                        </li>
                    </ul>
                </aside>
                <section className="flex-grow">
                    {view === DASHBOARDVIEW.GENERAL && <></>}
                    {view === DASHBOARDVIEW.LEADERBOARDS && <LeaderboardComponent {...props} />}
                </section>
            </section>
        </>
    )
}

export default DashboardMainComponent
